"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("./constants");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Lexer = exports["default"] = /*#__PURE__*/function () {
  function Lexer() {
    _classCallCheck(this, Lexer);
  }
  return _createClass(Lexer, [{
    key: "lex",
    value: function lex(text) {
      var tokens = [];
      this.text = text;
      this.index = 0;
      while (this.index < this.text.length) {
        var ch = this.text.charAt(this.index);
        if (this.isLogicalOperator(ch)) {
          tokens.push({
            value: ch
          });
          this.index++;
        } else if (this.isBracket(ch)) {
          tokens.push({
            value: ch
          });
          this.index++;
        } else if (this.isUnaryOperator(ch)) {
          tokens.push({
            value: ch
          });
          this.index++;
        } else {
          tokens.push({
            value: this.readText()
          });
        }
      }
      return tokens;
    }
  }, {
    key: "isLogicalOperator",
    value: function isLogicalOperator(ch) {
      return [_constants.OR, _constants.AND].includes(ch);
    }
  }, {
    key: "isUnaryOperator",
    value: function isUnaryOperator(ch) {
      return [_constants.NOT].includes(ch);
    }
  }, {
    key: "isBracket",
    value: function isBracket(ch) {
      return [_constants.OPEN_BRACKET, _constants.CLOSE_BRACKET].includes(ch);
    }
  }, {
    key: "isText",
    value: function isText(ch) {
      return !this.isLogicalOperator(ch) && !this.isBracket(ch) && !this.isUnaryOperator(ch);
    }
  }, {
    key: "readText",
    value: function readText() {
      var value = '';
      while (this.index < this.text.length) {
        var ch = this.text.charAt(this.index);
        if (this.isText(ch)) {
          value += ch;
          this.index++;
        } else {
          break;
        }
      }
      return value;
    }
  }]);
}();